import { Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  loading: boolean;

  handleApplyEmptyTemplate(): void;
}

const FromScratch: React.FC<Props> = ({ loading, handleApplyEmptyTemplate }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <Typography className={classes.text} mb={'8px'}>
        {t('createFromScratchInfo')}
      </Typography>
      <Typography className={classes.text} mb={'16px'}>
        {t('selectTemplateLater')}
      </Typography>
      <Stack direction={'row'} justifyContent={'center'}>
        <PaiButton text={t('continueWithoutTemplate')} border={'rounded'} size={'small'} loading={loading} action={handleApplyEmptyTemplate} />
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  text: {
    fontSize: theme.typography.pxToRem(15),
    textAlign: 'center',
  },
}));

export default FromScratch;
